/* Zucchi Recinzioni PVC — homepage interactions (vanilla, no deps) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---- FAQ accordion ------------------------------------------------------
  function initFaq(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zucchi-faq-btn]');
      if (!btn || !root.contains(btn)) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  // ---- Day/Night before/after compare slider ------------------------------
  function initDayNight(root) {
    var compare = root.querySelector('[data-zucchi-daynight-compare]');
    var range = compare && compare.querySelector('[data-zucchi-daynight-range]');
    if (!compare || !range) return; // single image / placeholder: nothing to wire

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      compare.style.setProperty('--pos', pct + '%');
      var rounded = Math.round(pct);
      if (+range.value !== rounded) range.value = rounded;
      range.setAttribute('aria-valuenow', rounded);
    }

    function posFromEvent(e) {
      var rect = compare.getBoundingClientRect();
      if (rect.width) setPos(((e.clientX - rect.left) / rect.width) * 100);
    }

    // Keyboard / assistive tech drive the native range input.
    range.addEventListener('input', function () { setPos(+range.value); });

    // Pointer: drag anywhere on the strip.
    var dragging = false;
    compare.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { compare.setPointerCapture(e.pointerId); } catch (err) {}
      if (e.pointerType === 'mouse') posFromEvent(e); // click-to-position (mouse only)
    });
    compare.addEventListener('pointermove', function (e) {
      if (dragging) posFromEvent(e);
    });
    function endDrag() { dragging = false; }
    compare.addEventListener('pointerup', endDrag);
    compare.addEventListener('pointercancel', endDrag);

    setPos(+range.value || 50);
  }

  // ---- Carousel arrows + bounds -------------------------------------------
  function initCarousel(root) {
    var track = root.querySelector('[data-zucchi-carousel-track]');
    var prev = root.querySelector('[data-zucchi-carousel-prev]');
    var next = root.querySelector('[data-zucchi-carousel-next]');
    if (!track) return;

    function slideWidth() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return first.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
    }

    function updateBtns() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { updateBtns(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updateBtns);
    updateBtns();
  }

  // ---- Smooth scroll for in-page anchors inside Zucchi sections -----------
  function initSmoothScroll(root) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !root.contains(a)) return;
      var id = a.getAttribute('href');
      if (id.length <= 1) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ---- Share buttons (article page) ---------------------------------------
  function initShare() {
    var btns = document.querySelectorAll('[data-zucchi-share]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var kind = btn.getAttribute('data-zucchi-share');
        var url = btn.getAttribute('data-url') || window.location.href;
        var title = btn.getAttribute('data-title') || document.title;
        var enc = encodeURIComponent;
        switch (kind) {
          case 'facebook':
            window.open('https://www.facebook.com/sharer.php?u=' + enc(url), '_blank', 'noopener,width=600,height=520');
            break;
          case 'x':
            window.open('https://twitter.com/intent/tweet?url=' + enc(url) + '&text=' + enc(title), '_blank', 'noopener,width=600,height=520');
            break;
          case 'whatsapp':
            window.open('https://api.whatsapp.com/send?text=' + enc(title + ' ' + url), '_blank', 'noopener');
            break;
          case 'copy':
            (navigator.clipboard && navigator.clipboard.writeText
              ? navigator.clipboard.writeText(url)
              : Promise.reject()
            ).then(function () {
              btn.setAttribute('data-state', 'copied');
              btn.setAttribute('data-copied-label', 'Copiato');
              setTimeout(function () {
                btn.removeAttribute('data-state');
              }, 1500);
            }).catch(function () {
              window.prompt('Copia il link', url);
            });
            break;
        }
      });
    });
  }

  // ---- Product hero (color swatch + variant sync) -------------------------
  function readVariants(productId) {
    var node = document.querySelector('[data-zucchi-variants-' + productId + ']');
    if (!node) return [];
    try { return JSON.parse(node.textContent); } catch (e) { return []; }
  }

  function initProductHero(root) {
    var productId = root.getAttribute('data-product-id');
    var colorIndex = parseInt(root.getAttribute('data-color-option-index'), 10);
    var swatches = root.querySelectorAll('[data-zucchi-swatch]');
    var heroImg  = root.querySelector('[data-zucchi-hero-img]');
    var mainWrap = heroImg ? heroImg.parentElement : null;
    if (!swatches.length || !heroImg) return;

    var variants = readVariants(productId);

    function findVariantForColor(colorValue) {
      if (!variants.length || isNaN(colorIndex) || colorIndex < 0) return null;
      // pick the first available variant whose option at colorIndex matches
      var pool = variants.filter(function (v) {
        return v.options && v.options[colorIndex] === colorValue;
      });
      if (!pool.length) return null;
      var available = pool.filter(function (v) { return v.available; });
      return available[0] || pool[0];
    }

    function activate(btn) {
      var color = btn.getAttribute('data-zucchi-swatch-color');
      var src    = btn.getAttribute('data-zucchi-swatch-image-src');
      var srcset = btn.getAttribute('data-zucchi-swatch-image-srcset');
      var alt    = btn.getAttribute('data-zucchi-swatch-image-alt');

      // visual state
      swatches.forEach(function (s) { s.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');

      // hero crossfade
      if (mainWrap) mainWrap.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = function () {
        heroImg.src = src;
        if (srcset) heroImg.srcset = srcset;
        if (alt) heroImg.alt = alt;
        requestAnimationFrame(function () {
          if (mainWrap) mainWrap.classList.remove('is-swapping');
        });
      };
      pre.onerror = function () {
        if (mainWrap) mainWrap.classList.remove('is-swapping');
      };
      pre.src = src;

      // URL ?variant=<id>
      var match = findVariantForColor(color);
      if (match && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn); });
    });
  }

  // ---- Scroll reveal (homepage only, progressive enhancement) -------------
  function initScrollReveal() {
    // Homepage only: the cinema hero is unique to the index template.
    if (!document.querySelector('.shopify-section-zucchi-hero-cinema')) return;
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    var SEL = '.z-section-head, .z-num-cell, .z-color-card, .z-element-card, .z-marquee, .z-bleed-section__inner, .z-config-band__body, .z-showroom-band, .z-faq__item, .z-cta-final';

    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.closest('.shopify-section-zucchi-hero-cinema')) return; // never touch the hero
      el.classList.add('z-reveal');
      var siblings = el.parentNode ? el.parentNode.children : [el];
      var idx = Array.prototype.indexOf.call(siblings, el);
      el.style.transitionDelay = (Math.min(idx, 5) * 60) + 'ms';
      io.observe(el);
    });
  }

  // ---- Marquee preload + decode-gate (no blank tiles when photos are heavy) ----
  function initMarquee(root) {
    var track = root.querySelector('.z-marquee__track');
    if (!track) return;
    var imgs = root.querySelectorAll('img');
    if (!imgs.length) return;

    root.classList.add('is-loading'); // pause the scroll until tiles are decoded
    var started = false;
    function start() {
      if (started) return;
      started = true;
      root.classList.remove('is-loading');
    }

    function preload() {
      var jobs = [];
      imgs.forEach(function (img) {
        try { img.loading = 'eager'; } catch (e) {}
        if (typeof img.decode === 'function') {
          jobs.push(img.decode().catch(function () {}));
        }
      });
      if (jobs.length) {
        Promise.all(jobs).then(start);
        setTimeout(start, 3000); // safety: never stay frozen even if a decode hangs
      } else {
        start();
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.disconnect(); preload(); }
        });
      }, { rootMargin: '300px 0px' }); // fetch/decode just before the strip is visible
      io.observe(root);
    } else {
      preload();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-zucchi-faq]').forEach(initFaq);
    document.querySelectorAll('[data-zucchi-daynight]').forEach(initDayNight);
    document.querySelectorAll('[data-zucchi-carousel]').forEach(initCarousel);
    document.querySelectorAll('.z-page').forEach(initSmoothScroll);
    document.querySelectorAll('[data-zucchi-product]').forEach(initProductHero);
    initShare();
    initScrollReveal();
    document.querySelectorAll('.z-marquee').forEach(initMarquee);
  });
})();
